import React from "react"
import Helmet from "react-helmet"
import Uninstall from "@tightrope/footerlinks/uninstall"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"

export default function UninstallPage() {
  return(

    <HomepageLayout>
        <Helmet data={JSONData}><title>Uninstall - Manuals By Clear</title></Helmet>
    <Uninstall></Uninstall>
    </HomepageLayout>
  )
}
